"use strict";

define('rs/form/formdiff/formdiff.controller',['rs/form/form.controller', 'rs/form/formdiff/formdiff.view'], function (FormController, FormDiffView) {
  var FormDiffController = FormController.extend({
    properties: ['diffController', 'emptyAnswers'],
    isDiffViewer: function isDiffViewer() {
      return true;
    },
    loadNewAnswerSet: function loadNewAnswerSet(answers) {
      this.applyAnswerData(answers);
      var formObjectData = {};
      for (var i = 0, len = answers.length; i < len; i++) {
        formObjectData[answers[i].id] = answers[i];
      }
      this.setFormObjectData(formObjectData);
    },
    updateSectionRoute: function updateSectionRoute() {},
    activateSection: function activateSection(section) {
      return this._super.apply(this, arguments).bind(this).tap(function () {
        this.applyDiffProperties();
      });
    },
    canEditDocument: function canEditDocument() {
      return false;
    },
    clearDiffCache: function clearDiffCache() {
      var sections = this.getSections();
      for (var i = 0, len = sections.length; i < len; i++) {
        sections[i]._diffApplied = undefined;
        sections[i]._diffData = undefined;
      }
    },
    shouldCheckUnsaved: function shouldCheckUnsaved() {
      return false;
    },
    shouldActivateDefaultSection: function shouldActivateDefaultSection() {
      return false;
    },
    applyDiffProperties: function applyDiffProperties() {
      var section = this.getActiveSection(),
        diffController = this.getDiffController();
      if (!section._diffApplied) {
        var view = this.getView(),
          hiddenFormObjects = diffController.getHiddenFormObjects(section),
          changedFormObjects = diffController.getChangedFormObjects(section);
        for (var i = 0; i < hiddenFormObjects.length; i++) {
          view.setDiffMode(hiddenFormObjects[i]);
        }
        section._diffApplied = true;
      }
    },
    setupView: function setupView() {
      this.setView(new FormDiffView());
    },
    shouldRenderFooter: function shouldRenderFooter() {
      return false;
    }
  });
  return FormDiffController;
});

